import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.payments')
  .factory('$payment', PaymentObjectFactory);

/* @ngInject */
function PaymentObjectFactory($bringozFactory: $bringozFactory,
                              PaymentsAPI: BringozApi,
                              Payments_DS: DataStoreConfig) {

  function $payment(id: string) {
    return $bringozFactory(id, PaymentsAPI, Payments_DS);
  }

  return $payment;
}
